import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-app-channel-not-supported",
	templateUrl: "./channel-not-supported.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ChannelNotSupportedComponent {}
